import { summarizeRowsAbove, COLUMN_IDS } from '../constants';

/**
 * @param gapAudios - array of {@link TrqkGapChannelAudio}s
 * @returns the initial state values to pass to the useTable() hook from react-table
 */
export const getInitialState = (
    gapAudios: TrqkGapChannelAudio[],
): ConfirmWorksTableInitialState => {
    const matchCounts = gapAudios.reduce(
        (acc: Record<string, number>, gapAudio: TrqkGapChannelAudio) => {
            const matchedWorkId = gapAudio?.matched_work_id ?? null;

            if (matchedWorkId) {
                if (acc[matchedWorkId]) {
                    acc[matchedWorkId] += 1;
                } else {
                    acc[matchedWorkId] = 1;
                }
            }

            return acc;
        },
        {},
    );

    /**
     * An object whose keys are row IDs and values are `true` when that row should be
     * initially selected.
     */
    const selected: Record<string, boolean> = gapAudios.reduce(
        (
            acc: Record<string, boolean>,
            { gap_audio_id, include }: TrqkGapChannelAudio,
        ) => {
            if (include) {
                acc[gap_audio_id] = true;
            }

            return acc;
        },
        {},
    );

    // Set state of initially expanded rows. If the matched_work_id was used in more than the
    // summarizeRowsAbove threshold, it will create a summarized row whose ID consists of a
    // concatenation of COLUMN_IDS.WORK_NAME with the matched_work_id . This is because of how we
    // have set up the row grouping with the groupByMatchState function.
    const expanded = Object.entries(matchCounts).reduce(
        (acc: Record<string, boolean>, curr) => {
            const [matchedWorkId, matchCount] = curr;

            if (matchCount > summarizeRowsAbove) {
                acc[`${COLUMN_IDS.WORK_NAME}:${matchedWorkId}`] = true;
            }

            return acc;
        },
        {},
    );

    return {
        selected,
        expanded,
    };
};
